export { hasCodeQualityReport } from '~/merge_requests/reports/configured_reports';

export const hasLicenseComplianceReport = (mr) => Boolean(mr?.enabledReports?.licenseScanning);

export const hasMetricsReport = (mr) => Boolean(mr?.metricsReportsPath);
